import { required, dataMember } from 'santee-dcts';

export class Distance {
    @required()
    @dataMember()
    public minutes: number;

    @required()
    @dataMember()
    public hours: number;

    @required()
    @dataMember()
    public days: number;

    @required()
    @dataMember()
    public ticks: number;

    @required()
    @dataMember()
    public formattedValue: string;

    public toString() {
        return this.formattedValue;
    }
}
